// extracted by mini-css-extract-plugin
module.exports = {"supportive-messages-block":"MessageCarouselBlock_supportive-messages-block__nshxj","heading":"MessageCarouselBlock_heading__2QXtd","button":"MessageCarouselBlock_button__4HX4m"};